import React, { useState } from 'react';
import { GameProvider, useGame, LEVELS } from './GameContext';
import LevelScreen from './LevelScreen';

function GameHome({ user, onBack }) {
  return (
    <GameProvider>
      <GameHomeInner user={user} onBack={onBack} />
    </GameProvider>
  );
}

function GameHomeInner({ user, onBack }) {
  const { state } = useGame();
  const [showLevel, setShowLevel] = useState(false);
  const currentLevel = LEVELS.find(l => l.id === state.currentLevel);
  if (showLevel) {
    return <LevelScreen onBack={() => setShowLevel(false)} />;
  }
  return (
    <div style={{ minHeight: '70vh', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'flex-start', padding: 24 }}>
      <button className="gogig-card-btn-outline" style={{ alignSelf: 'flex-start', marginBottom: 18 }} onClick={onBack}>&larr; Back</button>
      <h2 style={{ fontWeight: 800, fontSize: 28, color: '#22c55e', marginBottom: 8 }}>The Apprentice's Journey</h2>
      <div style={{ color: '#555', fontSize: 16, marginBottom: 18, textAlign: 'center', maxWidth: 400 }}>
        Welcome, {user.name || 'Player'}! Progress through levels, complete daily tasks and missions, and earn XP, coins, and badges.
      </div>
      <div style={{ display: 'flex', gap: 18, marginBottom: 24 }}>
        <StatCard label="XP" value={state.xp} color="#22c55e" />
        <StatCard label="Coins" value={state.coins} color="#fbbf24" />
        <StatCard label="Badges" value={state.badges.length} color="#3b82f6" />
      </div>
      <div style={{ background: '#f8fafc', border: '1.5px solid #e5e7eb', borderRadius: 16, padding: 24, maxWidth: 400, width: '100%', marginBottom: 24 }}>
        <div style={{ fontWeight: 700, fontSize: 20, marginBottom: 6 }}>{currentLevel.name}</div>
        <div style={{ color: '#666', fontSize: 15, marginBottom: 10 }}>{currentLevel.description}</div>
        <button className="gogig-card-btn" style={{ width: '100%' }} onClick={() => setShowLevel(true)}>Start / Continue</button>
      </div>
      <div style={{ color: '#888', fontSize: 14, marginTop: 12 }}>More games and rewards coming soon!</div>
    </div>
  );
}

function StatCard({ label, value, color }) {
  return (
    <div style={{ background: '#fff', borderRadius: 12, boxShadow: '0 2px 8px rgba(34,197,94,0.07)', padding: '14px 22px', minWidth: 80, textAlign: 'center', border: `2px solid ${color}` }}>
      <div style={{ fontWeight: 700, fontSize: 20, color }}>{value}</div>
      <div style={{ color: '#555', fontSize: 14 }}>{label}</div>
    </div>
  );
}

export default GameHome; 